import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Hexagon, LogIn } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid-bg flex min-h-screen items-center justify-center bg-ink px-4">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md rounded-xl border border-cy/20 bg-panel p-8 shadow-[0_0_60px_rgba(0,240,255,0.1)] sm:p-10"
        data-testid="admin-login-card"
      >
        <div className="flex items-center gap-3">
          <span className="relative grid h-10 w-10 place-items-center">
            <Hexagon className="h-10 w-10 text-cy" strokeWidth={1.4} />
            <span className="absolute font-display text-sm font-extrabold text-ink">Q</span>
          </span>
          <div className="leading-none">
            <p className="font-display text-base font-bold tracking-[0.18em] text-slate-100">QUANTUM</p>
            <p className="font-mono text-[11px] tracking-[0.34em] text-cy">CENTURY</p>
          </div>
        </div>
        <h1 className="mt-8 font-display text-2xl font-bold text-slate-50">Panel de administración</h1>
        <p className="mt-2 text-sm text-slate-400">Acceso exclusivo para el equipo de Quantum Century.</p>

        <form onSubmit={submit} className="mt-8 grid gap-4">
          <input
            data-testid="admin-login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Correo electrónico"
            className="w-full rounded-lg border border-cy/15 bg-qcard px-4 py-3 text-sm text-slate-200 placeholder:text-slate-600 outline-none transition-colors focus:border-cy/60"
          />
          <input
            data-testid="admin-login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Contraseña"
            className="w-full rounded-lg border border-cy/15 bg-qcard px-4 py-3 text-sm text-slate-200 placeholder:text-slate-600 outline-none transition-colors focus:border-cy/60"
          />
          {error && (
            <p data-testid="admin-login-error" className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-2 text-sm text-red-400">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="flex items-center justify-center gap-2 rounded-full bg-cy px-6 py-3.5 font-display text-sm font-bold text-ink transition-all hover:bg-em disabled:opacity-60"
          >
            <LogIn className="h-4 w-4" />
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>

        <Link to="/" className="mt-6 block text-center font-mono text-xs text-slate-500 transition-colors hover:text-cy" data-testid="admin-login-back">
          ← Volver a la página principal
        </Link>
      </motion.div>
    </div>
  );
}
